import { css } from '@emotion/react';
import { theme } from '@frontend/theme';

export const smallBannerStyle = css({
  padding: theme.spacing(0.5, 1),
  gap: theme.spacing(0.5),
  svg: { height: 16, width: 16 },
});
